import {Card, CardContent, CardHeader, CardTitle} from "../ui/card.tsx";
import {useTranslation} from "react-i18next";
import {Edit3, SettingsIcon, User} from "lucide-react";
import {CalendarIcon} from "@radix-ui/react-icons";

interface FeatureProps {
    icon: JSX.Element;
    title: string;
    description: string;
}

export const HowItWorks = () => {
    const {t} = useTranslation();

    const features: FeatureProps[] = [
        {
            icon: <Edit3/>,
            title: t("common.stepX", {"step": 1}),
            description: t("landing.step1Desc"),
        },
        {
            icon: <SettingsIcon/>,
            title: t("common.stepX", {"step": 2}),
            description: t("landing.step2Desc"),
        },
        {
            icon: <User/>,
            title: t("common.stepX", {"step": 3}),
            description: t("landing.step3Desc"),
        },
        {
            icon: <CalendarIcon/>,
            title: t("common.stepX", {"step": 4}),
            description: t("landing.step4Desc"),
        },
    ];

    return (
        <section
            id="howItWorks"
            className="container text-center py-24 sm:py-32"
        >
            <h2 className="text-3xl md:text-4xl font-bold ">
                {t("landing.howItWorks")}
            </h2>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {features.map(({icon, title, description}: FeatureProps) => (
                    <Card
                        key={title}
                        className="bg-muted/50"
                    >
                        <CardHeader>
                            <CardTitle className="grid gap-4 place-items-center">
                                {icon}
                                {title}
                            </CardTitle>
                        </CardHeader>
                        <CardContent>{description}</CardContent>
                    </Card>
                ))}
            </div>
        </section>
    );
};
